import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeletePlaylistItemDocument } from './delete.generated';

export const useDeletePlaylistItem = (
  options: ApiOptions<typeof DeletePlaylistItemDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(DeletePlaylistItemDocument, {
    ...useNotifications(DeletePlaylistItemDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deletePlaylistItem?.removedIds.length ?? 0;
        return t('api.playlist_items.delete_success_plural', { count });
      },
    }),

    ...options,
  });
};
